<div class="container">
    <ng-container *ngIf="isReadMode; else writeMode">
    <span>{{ value }}</span>
    </ng-container>
    <ng-template #writeMode>
        <div class="write-mode-container">
            <mat-form-field appearance="outline">
                <textarea class="no-resize" matInput [ngModel]="value" (ngModelChange)="onValueChange($event)" (blur)="onBlur()" [disabled]="effectiveDisabled" maxlength="256"></textarea>
            </mat-form-field>
        </div>
    </ng-template>
</div>